import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileCloudNewFeaturesModal = () => openPopupHelper({ popupName: popupNames.MOBILE_CLOUD_NEW_FEATURES });
